export function initQuiz() {
    const blockQuiz = document.querySelector('.quiz');

if (blockQuiz) {
const btQuiz = document.getElementById('btQuiz');

if (btQuiz) {
  btQuiz.addEventListener('click', function () {
    // Garante que o quiz abra limpo no slide 1
    reiniciarQuiz();

    // Abre o modal
    const modalQuiz = document.getElementById('modalQuiz');
    if (modalQuiz) {
      modalQuiz.classList.add('is--visible');
      document.body.classList.add('has--modal');
    }
  });
}

    // const btFecharQuiz = document.getElementById('fecharQuiz');
    // btFecharQuiz.addEventListener('click', fecharQuiz);

    // function fecharQuiz() {
    //     const modalQuiz = document.getElementById('modalQuiz');
    //     modalQuiz.classList.remove('is--visible');
    //     document.body.classList.remove('has--modal');
    // }

    //marcar 1 card de cada carrossel

// ==========================================
  // ETAPA 1: ESTADO GLOBAL E ESTRUTURA DE DADOS
  // ==========================================
  const estadoQuiz = {
    respostas: {},       // { 0: [1], 1: [1, 4], 2: [2], 3: [3] }
    pontuacao: [0, 0, 0, 0],
    perfilResultado: null
  };

  function registrarResposta(indicePergunta, perfisString) {
    const perfis = perfisString.split(',').map(p => parseInt(p.trim(), 10));
    estadoQuiz.respostas[indicePergunta] = perfis;
  }

  function resetarEstadoQuiz() {
    estadoQuiz.respostas = {};
    estadoQuiz.pontuacao = [0, 0, 0, 0];
    estadoQuiz.perfilResultado = null;
  }

  function todasPerguntasRespondidas() {
    const totalPerguntas = 4;
    for (let i = 0; i < totalPerguntas; i++) {
      if (!estadoQuiz.respostas[i]) return false;
    }
    return true;
  }

  // ==========================================
  // INICIALIZAÇÃO DOS SWIPERS
  // ==========================================
  
  // 1. Carrossel principal de perguntas
  var swiperPerguntas = new Swiper('.quiz-perguntas', {
    spaceBetween: 0,
    effect: 'fade',
    observer: true,
    observeParents: true,
    allowTouchMove: false, // Evita trocar de pergunta arrastando sem responder
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.quiz-modal__nav',
    }
  });

  // 2. Carrosséis individuais de respostas (cards)
  const slidesPerguntas = document.querySelectorAll('.quiz-perguntas > .swiper-wrapper > .swiper-slide');

  slidesPerguntas.forEach(slide => {
    const swiperContainer = slide.querySelector('.quiz-respostas .swiper');
    const btnNext = slide.querySelector('.swiper-button-next');
    const btnPrev = slide.querySelector('.swiper-button-prev');

    if (swiperContainer) {
      new Swiper(swiperContainer, {
        spaceBetween: 0,
        centeredSlides: true,
        slideToClickedSlide: false,
        loop: false,
        freeMode: false,
        observer: true,
        observeParents: true,
        effect: "creative",
        creativeEffect: {
          limitProgress: 3,
          prev: {
            translate: ['-60px', 10, 0],
            rotate: [0, 0, -10],
            scale: 0.9,
          },
          next: {
            translate: ['60px', 10, 0],
            rotate: [0, 0, 10],
            scale: 0.9,
          },
        },
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
      });
    }
  });

  // ==========================================
  // ETAPA 2 & 3: EVENTOS E AVANÇO AUTOMÁTICO
  // ==========================================
  
  // Mapeia os botões "Selecionar" dentro dos slides de perguntas (desconsidera o slide de resultado final)
  slidesPerguntas.forEach((slidePergunta, indicePergunta) => {
    // Ignora a última tela (tela do botão "Ver resultado")
    if (indicePergunta >= 4) return;

    const botoesResposta = slidePergunta.querySelectorAll('.quiz-respostas-card__btn');

    botoesResposta.forEach(botao => {
      botao.addEventListener('click', function (e) {
        e.preventDefault();

        const cardAtual = this.closest('.quiz-respostas-card');
        const perfis = this.getAttribute('data-perfil');

        if (!cardAtual || !perfis) return;

        // 1. Destaque visual: remove de todos e adiciona no selecionado
        const todosCards = slidePergunta.querySelectorAll('.quiz-respostas-card');
        todosCards.forEach(card => card.classList.remove('selected'));
        cardAtual.classList.add('selected');

        // 2. Registra na memória (Etapa 1)
        registrarResposta(indicePergunta, perfis);

        // 3. Avança para a próxima pergunta após 350ms (Etapa 3)
        setTimeout(() => {
          swiperPerguntas.slideNext();
        }, 350);
      });
    });
  });

  // Botão "Ver Resultado" no slide final
  // const btnResultado = document.getElementById('btnVerResultado');
  // if (btnResultado) {
  //   btnResultado.addEventListener('click', function () {
  //     if (!todasPerguntasRespondidas()) {
  //       alert('Por favor, responda todas as 4 perguntas para ver o seu perfil!');
  //       return;
  //     }

  //     console.log('[QUIZ] Respostas registradas com sucesso:', estadoQuiz.respostas);
  //     // Próximo passo: chamar a função da Etapa 4 aqui!
  //   });
  // }

// ==========================================
// ETAPA 4: APURAÇÃO E CÁLCULO DO PERFIL
// ==========================================

function calcularResultado() {
  // 1. Zera a pontuação antes de contar
  // Índice 0 = Perfil 1, Índice 1 = Perfil 2, Índice 2 = Perfil 3, Índice 3 = Perfil 4
  const pontos = [0, 0, 0, 0];

  // 2. Mapeia e contabiliza cada resposta do usuário
  Object.keys(estadoQuiz.respostas).forEach(indicePergunta => {
    const perfisSelecionados = estadoQuiz.respostas[indicePergunta];

    perfisSelecionados.forEach(perfilNum => {
      // Como o perfil vai de 1 a 4, subtraímos 1 para casar com o índice do array (0 a 3)
      if (perfilNum >= 1 && perfilNum <= 4) {
        pontos[perfilNum - 1] += 1;
      }
    });
  });

  // Atualiza no estado global
  estadoQuiz.pontuacao = pontos;

  // 3. Identifica qual perfil obteve a maior pontuação
  let maiorPontuacao = -1;
  let perfilVencedor = 1; // Padrão Perfil 1

  pontos.forEach((qtdPontos, index) => {
    const numeroPerfil = index + 1;

    if (qtdPontos > maiorPontuacao) {
      maiorPontuacao = qtdPontos;
      perfilVencedor = numeroPerfil;
    } 
    // Regra de Desempate: Se houver empate na pontuação máxima
    else if (qtdPontos === maiorPontuacao) {
      // Exemplo de desempate: prioriza a escolha feita na Pergunta 1 (índice 0)
      const respostaPergunta1 = estadoQuiz.respostas[0] || [];
      if (respostaPergunta1.includes(numeroPerfil)) {
        perfilVencedor = numeroPerfil;
      }
    }
  });

  // Salva o resultado final no estado
  estadoQuiz.perfilResultado = perfilVencedor;

  console.log('[QUIZ] Placar Final:', pontos);
  console.log(`[QUIZ] Perfil Vencedor: Perfil ${perfilVencedor}`);

  return perfilVencedor;
}

// Localiza o botão na última tela do quiz
const btnResultado = document.getElementById('btnVerResultado');

if (btnResultado) {
  btnResultado.addEventListener('click', function (e) {
    e.preventDefault();

    // 1. Valida se o usuário respondeu todas as 4 perguntas
    if (!todasPerguntasRespondidas()) {
      alert('Por favor, responda todas as perguntas antes de ver o resultado!');
      return;
    }

    // 2. Calcula a pontuação e obtém o número do perfil vencedor (1, 2, 3 ou 4)
    const perfilVencedor = calcularResultado();

    // 3. Oculta as perguntas, renderiza os cards do perfil e exibe o resultado
    exibirResultado(perfilVencedor);
  });
}

// ==========================================
// ETAPA 5: EXIBIÇÃO DO RESULTADO E RESET
// ==========================================

// Base de dados com as informações e cards de cada perfil
const dadosPerfis = {
  1: {
    titulo: "PERFIL 01",
    subtitulo: "Jovens (em busca de propósito e esperança)",
    destaque: "A força da juventude plena de significado e que transforma o mundo.",
    descricao: "Na BSGI, a juventude é o coração do movimento pela felicidade da humanidade. Reconhecendo que é nos jovens que repousa a esperança do futuro, oferecemos o maior número de meios para que eles possam expressar sua individualidade e sua força de forma criativa e construtiva, sempre com vistas à transformação do próprio destino e à construção de um mundo onde a dignidade da vida seja o valor supremo.",
    cards: [
      {
        tipo: "Projeto",
        nome: "Juventude Soka",
        descricao: "Por seu dinamismo, capacidade de inovação e paixão, os jovens são considerados “a fonte da vibrante energia da organização”. Filosofia pedagógica humanística idealizada para contribuir com a paz e o bem-estar da sociedade.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/uploads/2026/06/card-juventude.jpg",
        url: "https://wpdev.bsgi.com.br/juventude-soka/"
      },
      {
        tipo: "Livro",
        nome: "Vozes para um futuro brilhante",
        descricao: "Diálogo com jovens estudantes sobre desafios da vida — inspire-se a encontrar sabedoria interior para construir seu próprio caminho. Acompanhe o legado dos mestres e descubra como a reforma interior de um único indivíduo pode mudar o destino de uma nação.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/livro-perfil1.jpg",
        url: "https://cile.brasilseikyo.com.br/livro-vozes-para-um-futuro-brilhante"
      },
      {
        tipo: "Livro",
        nome: "Seja a Esperança",
        descricao: "Compilação de mensagens de Daisaku Ikeda aos jovens. Em capítulos curtos e inspiradores, aborda autenticidade, sonhos, desafios globais como armas nucleares, racismo e discriminação, encerrando com relatos de sua própria juventude.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-seja-a-esperanca.webp",
        url: "https://cile.brasilseikyo.com.br/livro-seja-a-esperanca"
      },
    ]
  },
  2: {
    titulo: "PERFIL 02",
    subtitulo: "Pais e mães (em busca de assuntos relacionados à educação e valores)",
    destaque: "Criando valores para o futuro.",
    descricao: "Conheça o Sistema de Ensino Soka e nossas iniciativas educacionais. Criada por educadores em 1930, a Soka Gakkai defende que a educação é a base para uma sociedade mais justa e harmoniosa.",
    cards: [
      {
        tipo: "Projeto",
        nome: "Educação Soka",
        descricao: "A educação Soka se baseia na teoria de criação de valor e tem como objetivo o despertar do potencial de cada aluno. Um espaço de valorização daquilo que cada ser humano tem de melhor: a capacidade de traduzir o que pensa e sente por meio de sua criatividade.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/uploads/2026/06/card-educacao.jpg",
        url: "https://wpdev.bsgi.com.br/educacao-soka/"
      },
      {
        tipo: "Livro",
        nome: "Educação Soka",
        descricao: "Uma análise crítica da educação contemporânea e de seus desafios. Daisaku Ikeda apresenta os princípios da pedagogia Soka, propondo uma educação voltada à excelência acadêmica e à formação de cidadãos comprometidos com a felicidade e o progresso da humanidade.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/livro-perfil2.jpg",
        url: "https://cile.brasilseikyo.com.br/livro-educacao-soka"
      },
      {
        tipo: "Livro",
        nome: "A Família Criativa",
        descricao: "Coletânea de ensaios sobre família, relacionamentos familiares e a importância de construir uma vida familiar criativa, produtiva e transformadora, capaz de promover a realização pessoal e inspirar contribuições positivas para a sociedade.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-a-familia-criativa.webp",
        url: "https://cile.brasilseikyo.com.br/livro-a-familia-criativa"
      },
    ]
  },
  3: {
    titulo: "PERFIL 03",
    subtitulo: "Pessoas que já conhecem o budismo (estudo aprofundado)",
    destaque: "Aprofunde seus conhecimentos sobre a filosofia budista. ",
    descricao: "Explore a essência do Sutra do Lótus, o Nam-myoho-renge-kyo e mergulhe nos ensinamentos do Budismo de Nichiren Daishonin. Descubra como podemos aplicar essa energia vital em nossa vida diária e como podemos manifestar o potencial ilimitado que existe dentro de nós.",
    cards: [
      {
        tipo: "",
        nome: "Filosofia",
        descricao: "Contribuímos para que todo ser humano desperte para a felicidade e para o vasto potencial que possui na construção da paz e da prosperidade social.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/uploads/2026/06/bg-doacoes-1.jpg",
        url: "https://wpdev.bsgi.com.br/filosofia"
      },
      {
        tipo: "Livro",
        nome: "Vida — Um Enigma, uma Joia Preciosa",
        descricao: "Reflexão sobre questões como vida, morte, renascimento, sonhos, tempo e espaço à luz da sabedoria budista. O autor explora a vida interior, as relações humanas e a sociedade, oferecendo perspectivas para ampliar a compreensão e elevar a condição de vida.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-vida.webp",
        url: "https://cile.brasilseikyo.com.br/livro-vida"
      },
      {
        tipo: "Livro",
        nome: "Preleção Sutra do Lótus",
        descricao: "Preleção do Sutra do Lótus voltada a quem busca desenvolver seu potencial por meio da prática e do estudo do budismo. Mais que um livro, é um companheiro de jornada, recomendado para transformar o estudo em base para uma vida grandiosa.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-sutra-do-lotus.webp",
        url: "https://cile.brasilseikyo.com.br/livro-prelecao-sutra-do-lotus"
      },
    ]
  },
  4: {
    titulo: "PERFIL 04",
    subtitulo: "Interessados em cultura e sociedade",
    destaque: "Humanismo em ação: Cultura, Saúde e Meio Ambiente.",
    descricao: "Conheça nossos núcleos (saúde, cientistas, juristas, artistas). Em parceria com o Instituto Soka Amazônia, a BSGI promove a exposição “Sementes da Esperança e Ação – Tornando os ODS uma Realidade” e possui grupos artísticos como a Orquestra Filarmônica Brasileira do Humanismo Ikeda, unindo arte e bem-estar social.",
    cards: [
      {
        tipo: "Projeto",
        nome: "Arte e Cultura",
        descricao: "A arte e a cultura têm a força para transcender as diferenças de raça, nacionalidade, religião e costumes, e cria um laço entre os corações. Base do Budismo Nichiren, que contém uma filosofia de igualdade, não discriminação e respeito à dignidade da vida humana.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/uploads/2026/06/card-arte.jpg",
        url: "https://wpdev.bsgi.com.br/arte-cultura/"
      },
      {
        tipo: "Projeto",
        nome: "Sustentabilidade",
        descricao: "A BSGI defende a sustentabilidade focada na dignidade da vida e no empoderamento, transformando cada pessoa em um agente de mudança comunitária para uma sociedade global solidária.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/uploads/2026/06/card-sustentabilidade.jpg",
        url: "https://wpdev.bsgi.com.br/sustentabilidade"
      },
      {
        tipo: "Livro",
        nome: "O Valor da Vida",
        descricao: "Diálogo entre Daisaku Ikeda e Ernst Ulrich von Weizsäcker sobre recursos naturais e sustentabilidade. Em oito conversas, os autores discutem energia limpa, desafios ambientais e as transformações necessárias para construir um futuro sustentável.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-valor-da-vida.webp",
        url: "https://cile.brasilseikyo.com.br/livro-o-valor-da-vida"
      },
      {
        tipo: "Livro",
        nome: "Romper Barreiras",
        descricao: "Essa obra reúne um importante diálogo entre Herbie Hancock, Wayne Shorter e o Dr. Daisaku Ikeda que, juntos, discutem temas relacionados à história da humanidade, ao budismo e à música.",
        imagem: "https://wpdev.bsgi.com.br/wp-content/themes/bsgi-by-housecricket/images/quiz-romper-barreiras.webp",
        url: "https://cile.brasilseikyo.com.br/livro-romper-barreiras"
      },
    ]
  }
};

/**
 * Exibe a div de resultado e atualiza os textos de acordo com o perfil vencedor
 * @param {number} perfilNum - Número do perfil (1, 2, 3 ou 4)
 */
// Variável global para controlar a instância do Swiper do resultado
let swiperResultadoInstance = null;

function exibirResultado(perfilNum) {
  const perfilData = dadosPerfis[perfilNum] || dadosPerfis[1];

  // 1. Oculta perguntas e exibe área de resultado
  const quizPerguntas = document.querySelector('.quiz-perguntas');
  const quizResultado = document.querySelector('.quiz-resultado');

  if (quizPerguntas) quizPerguntas.style.display = 'none';
  if (quizResultado) quizResultado.style.display = 'block';

  // 2. Atualiza os textos do cabeçalho
  const ttlElement = document.querySelector('.quiz-resultado__ttl');
  const txtElement = document.querySelector('.quiz-resultado__txt');

  if (ttlElement) {
    ttlElement.innerHTML = `
      <h2>${perfilData.titulo}</h2>
      <h3>${perfilData.subtitulo}</h3>
    `;
  }

  if (txtElement) {
    txtElement.innerHTML = `
      <p><strong>${perfilData.destaque}</strong></p>
      <p>${perfilData.descricao}</p>
    `;
  }

  // 3. Monta dinamicamente o HTML dos cards
  const wrapperCards = document.querySelector('.carrossel-resultados .swiper-wrapper');

  if (wrapperCards && perfilData.cards) {
    // Destrói a instância anterior do Swiper se já estiver rodando
    if (swiperResultadoInstance) {
      swiperResultadoInstance.destroy(true, true);
      swiperResultadoInstance = null;
    }

    // Gera o HTML de cada card
    let cardsHTML = '';
    perfilData.cards.forEach(card => {
      cardsHTML += `
        <div class="swiper-slide">
          <div class="carrossel-resultados-card">
            ${card.imagem ? `
              <figure class="carrossel-resultados-card__figure">
                <img src="${card.imagem}" alt="${card.nome}" />
              </figure>
            ` : ''}
            <div class="carrossel-resultados-card__cover">
              <h4>${card.tipo}</h4>
              <h5>${card.nome}</h5>
              <div class="carrossel-resultados-card__cover-txt">
                ${card.descricao ? `
                  <div class="carrossel-resultados-card__cover-cont">
                    <p>${card.descricao}</p>
                    ${card.url ? `<a href="${card.url}">Acesse</a>` : ''}
                  </div>
                ` : ''}
              </div>
            </div>
          </div>
        </div>
      `;
    });

    // Injeta o novo HTML na tela
    wrapperCards.innerHTML = cardsHTML;

    // 4. Reinicializa o Swiper para se adaptar ao novo conteúdo inserido
    if (typeof Swiper !== 'undefined') {
      swiperResultadoInstance = new Swiper('.carrossel-quiz-resultados .swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.carrossel-quiz-resultados .swiper-button-next',
          prevEl: '.carrossel-quiz-resultados .swiper-button-prev',
        },
        pagination: {
          el: '.carrossel-quiz-resultados .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }
      });
    }
  }
}

/**
 * Reseta completamente o quiz para o estado inicial
 */
function reiniciarQuiz() {
  // 1. Limpa os dados de respostas e pontuação guardados na memória
  resetarEstadoQuiz();

  // 2. Remove a classe .selected de todos os cards
  document.querySelectorAll('.quiz-respostas-card').forEach(card => {
    card.classList.remove('selected');
  });

  // 3. Exibe novamente o carrossel de perguntas e esconde a área de resultado
  const quizPerguntas = document.querySelector('.quiz-perguntas');
  const quizResultado = document.querySelector('.quiz-resultado');

  if (quizPerguntas) quizPerguntas.style.display = 'block';
  if (quizResultado) quizResultado.style.display = 'none';

  // 4. Se existir a instância do Swiper de resultados, destrói para não acumular memória
  if (typeof swiperResultadoInstance !== 'undefined' && swiperResultadoInstance) {
    swiperResultadoInstance.destroy(true, true);
    swiperResultadoInstance = null;
  }

  // 5. Retorna o Swiper das perguntas para o slide 1 (índice 0) sem animação pesada
  if (typeof swiperPerguntas !== 'undefined' && swiperPerguntas) {
    swiperPerguntas.slideTo(0, 0);
  }
}

// ==========================================
// EVENTO DO BOTÃO FECHAR QUIZ (#fecharQuiz)
// ==========================================
const btnFechar = document.getElementById('fecharQuiz');

if (btnFechar) {
  btnFechar.addEventListener('click', function (e) {
    e.preventDefault();

    // 1. Oculta o modal do quiz (ajuste a classe de acordo com o seu CSS de modal)
    const modalQuiz = document.getElementById('modalQuiz');
    if (modalQuiz) {
      modalQuiz.classList.remove('is--visible');
       document.body.classList.remove('has--modal');
    }

    // 2. Aguarda um breve instante para o modal fechar visualmente e reseta tudo
    setTimeout(() => {
      reiniciarQuiz();
    }, 300);
  });
}









}
    
}